document.addEventListener('swup:clickLink', (event) => {
  const parent = document.querySelector('.transition-takeover');
  const random = Math.floor(1 + Math.random() * parent.childElementCount);
  parent.querySelectorAll('p').forEach( element => {
    element.classList.remove('active');
  });
  parent.querySelector('p:nth-child(' + random + ')').classList.add('active');
});
